module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#health",
      toString: function () {
        return this.url;
      }
    }